import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Modal, Button, Dropdown, Menu} from 'antd'
import {
  QuestionCircleFilled,
  ScheduleOutlined,
  EllipsisOutlined,
  LockOutlined,
  UnlockOutlined,
  InfoCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  RightCircleOutlined
} from '@ant-design/icons'
import FormModal from './FormModal'
import FormModal2 from './FormModal2'
import FormModalVersion from '../../mappingManagement/components/FormModalVersion'
import BoundModal from './BoundModal'
import {withTranslation} from 'react-i18next'

const storage = window.localStorage
const {confirm} = Modal

@inject('apiManagementStore', 'mappingManagementStore')
@observer
class SearchResult extends Component {
  state = {
    boundVisible: false,
    addModalVisible: false,
    addModalVisible2: false,
    modalVisibleVersion: false,
    record: null
  }
  handleSchedule = (record) => {
    const {apiManagementStore} = this.props
    apiManagementStore.onSearchScheduleAction(record.id).then(
      res => {
        this.setState({
          addModalVisible: true,
          record: record
        })
      })
  }
  handleSchedule2 = (record) => {
    const {apiManagementStore} = this.props
    apiManagementStore.onSearchScheduleAction(record.id).then(
      res => {
        this.setState({
          addModalVisible2: true,
          record: record
        })
      })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleCancel2 = () => {
    this.setState({
      addModalVisible2: false
    })
  }
  handleBoundCancel = () => {
    this.setState({
      boundVisible: false
    })
  }
  handleResearch = (direction) => {
    const {search} = this.props
    search(direction)
  }
  handleBoundEdit = (record) => {
    this.setState({
      boundVisible: true,
      record: record
    })
  }
  handleChangeActive = (record) => {
    const {apiManagementStore} = this.props
    const {directionType} = apiManagementStore
    // 	const activeStatus = record.status === 'Normal'
    // if(directionType==='OUTBOUND') {
    //   apiManagementStore.onChangeStatus(record.id, !activeStatus);
    // }else {
    //   apiManagementStore.onChangeInboundStatus(record.id, !activeStatus);
    // }
    const activeStatus = record.status === 'Normal' ? 'Inactive' : 'Active'
    if (directionType === 'OUTBOUND') {
      apiManagementStore.onChangeStatus(record.id, activeStatus)
    } else {
      apiManagementStore.onChangeInboundStatus(record.id, activeStatus)
    }
  }
  handlePageChange = (page, pageSize) => {
    const {apiManagementStore} = this.props
    apiManagementStore.onChangePageNumAction(page, pageSize)
  }
  handlePing = (record) => {
    const {apiManagementStore} = this.props
    apiManagementStore.onPingAction(record.id)
  }
  handleVersion = (record) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onSearchVersionAction(record.id, 'API')
    this.setState({
      modalVisibleVersion: true,
      record: record
    })
  }
  handleDelete = (record) => {
    const {apiManagementStore, t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        apiManagementStore.delAction(record.id)
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }

  handleEdit = () => {
    // const { apiManagementStore } = this.props;
    // apiManagementStore.delAction(record.id);
  }

  handleCancelVersion = () => {
    this.setState({
      modalVisibleVersion: false
    })
  }
  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  handleRun = (record) => {
    const {apiManagementStore, t} = this.props
    confirm({
      title: t(`general.run`),
      icon: <QuestionCircleFilled/>,
      content: t(`apiManagement.trigSuccessInfo`),
      okText: t(`general.ok`),
      cancelText: t(`general.cancel`),
      onOk() {
        apiManagementStore.runTask(record)
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {apiManagementStore, t} = this.props
    const {pageNo, pageSize, itemCount, apiList, directionType} = apiManagementStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(apiList)} pagination={pagination} rowClassName={this.getRowClassName} rowKey="id"
               scroll={{x: '100%', scrollToFirstRowOnChange: true}}>
          <Table.Column align="center" width={80} title={t(`apiManagement.status`)} dataIndex="status" key="status" ellipsis={true}
                        render={(text) => <div style={{
                          display: 'inline-block',
                          height: 24,
                          width: 24,
                          lineHeight: '24px',
                          fontSize: 12,
                          borderRadius: 24,
                          color: 'white',
                          textAlign: 'center',
                          background: text === 'Normal' ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : text === 'Abnormal' ? themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e' : themeStyle?.statusColor?.split(',')?.[2] || '#7ac3e0'
                        }} title={text}>{text.charAt(0)}</div>}
          />
          <Table.Column width={300} title={t(`apiManagement.connectName`)} dataIndex="apiName" key="apiName" ellipsis={true}/>
          <Table.Column width={300} title={t(`apiManagement.connectShortName`)} dataIndex="apiShortName" key="apiShortName" ellipsis={true}/>
          <Table.Column width={150} title={t(`apiManagement.customer`)} dataIndex="customerStr" key="customerStr" ellipsis={true}/>
          <Table.Column width={150} title={t(`apiManagement.businessType`)} dataIndex="businessType" key="businessType" ellipsis={true}/>
          <Table.Column width={150} title={t(`apiManagement.direction`)} dataIndex="direction" key="direction" ellipsis={true}/>
          <Table.Column width={150} title={t(`apiManagement.dataIngestion`)} dataIndex="dataIngestion" key="dataIngestion" ellipsis={true}
                        render={(text, record) => (
                          <div>
                            {
                              record.dataIngestion === 'DATATARGET' ? <div>{t(`apiManagement.dataTarget`)}</div> :
                                <div>{t(`apiManagement.dataSource`)}</div>
                            }
                          </div>
                        )}></Table.Column>
          <Table.Column width={150} title={t(`apiManagement.dataType`)} dataIndex="dataType" key="dataType" ellipsis={true}></Table.Column>
          <Table.Column fixed="right" width={140} align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleBoundEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              {/* {record.direction === 'OUTBOUND' ? <Button type='link' onClick={() => this.handlePing(record)} icon={<ApiFilled />} title='Ping Channel' /> : null} */}
              <Button type="link" onClick={() => this.handleChangeActive(record)} className={record.status === 'Normal' ? null : 'grey'}
                      icon={record.status === 'Normal' ? <UnlockOutlined/> : <LockOutlined/>}
                      title={record.status === 'Normal' ? t(`general.active`) : t(`general.inactive`)}/>

              <Dropdown overlay={<Menu items={
                ((record.direction === 'INBOUND' && record.dataIngestion === 'DATATARGET' && (record.dataType === 'HTTP' || record.dataType === 'DB')) || (record.direction === 'INBOUND' && record.dataIngestion === 'DATASOURCE' && (record.dataType === 'DB' || record.dataType === 'SFTP' || record.dataType === 'Blob'))) ? [
                  // {label: t(`general.schedule`), key: 'schedule',icon: <ScheduleOutlined />, onClick: ()=>this.handleSchedule2(record), disabled: record.scheduledConfigInfo?.period && record.scheduledConfigInfo?.enable},
                  {label: t(`general.run`), key: 'run',icon: <RightCircleOutlined />, onClick: ()=>this.handleRun(record), loading: record.isLoading,},
                  {label: t(`general.version`), key: 'version', icon: <InfoCircleOutlined />, onClick: ()=>this.handleVersion(record)},
                  {label: t(`general.delete`), key: 'delete', icon: <DeleteOutlined />, onClick: ()=>this.handleDelete(record)},
                ]: [
                  {label: t(`general.version`), key: 'version', icon: <InfoCircleOutlined />, onClick: ()=>this.handleVersion(record)},
                  {label: t(`general.delete`), key: 'delete', icon: <DeleteOutlined />, onClick: ()=>this.handleDelete(record)}
                ]
              }/>}>
                <Button type='link' icon={<EllipsisOutlined />}  />
              </Dropdown>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          record={this.state.record}
        /> : null}
        {this.state.addModalVisible2 ? <FormModal2
          addModalVisible2={this.state.addModalVisible2}
          handleCancel={this.handleCancel2}
          record={this.state.record}
        /> : null}
        {this.state.modalVisibleVersion ? <FormModalVersion
          title={'API'}
          addModalVisible={this.state.modalVisibleVersion}
          handleCancel={this.handleCancelVersion}
          record={this.state.record}
        /> : null}
        {this.state.boundVisible ? <BoundModal
          boundVisible={this.state.boundVisible}
          handleCancel={this.handleBoundCancel}
          handleResearch={this.handleResearch}
          direction={directionType}
          record={this.state.record}
          title="edit"
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
